class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictive-search');
        this.clearBtn = this.querySelector('.supsearch__clear');
        this.seatchBtn = this.querySelector('.supsearch__submit');
        // console.log(this.suggestedTitle);
        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));

        if (this.clearBtn) {
            this.clearBtn.addEventListener('click', () => this.clearcontent());
        }
        this.input.addEventListener('click', () => this.inputClick());
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            if (this.clearBtn) {
                this.clearBtn.style.display = 'none';
            }
            // if (this.seatchBtn) {
            //     this.seatchBtn.classList.remove('active');
            // }
            this.close();
            return;
        } else {
            if (this.clearBtn) {
                this.clearBtn.style.display = 'block';
            }
            // if (this.seatchBtn) {
            //     this.seatchBtn.classList.add('active');
            // }
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-searchse`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');
                const resultsMarkup = doc.querySelector('#shopify-section-predictive-searchse').innerHTML;
                const noResultElement = doc.querySelector('#search-noresult');

                const highlightedMarkup = this.highlightSearchTerm(resultsMarkup, searchTerm);
                this.predictiveSearchResults.innerHTML = highlightedMarkup;

                if (noResultElement) {
                    this.showSuggestedTitle(false);
                } else {
                    this.showSuggestedTitle(true);
                }

                this.open();
            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    highlightSearchTerm(resultsMarkup, searchTerm) {
     
        const words = searchTerm.split(/\s+/);

        words.forEach(word => {
            const regex = new RegExp(`(${word})`, 'gi');
            resultsMarkup = resultsMarkup.replace(/(<span[^>]*>)(.*?)(<\/span>)/gi, (match, openingTag, textContent, closingTag) => {
                const highlightedText = textContent.replace(regex, (match) => {
                    return `<i>${match}</i>`;
                });
                return `${openingTag}${highlightedText}${closingTag}`;
            });
        });

        return resultsMarkup;
    }


    

    clearcontent() {
        this.input.value = '';
        this.onChange();
    }

    inputClick() {
        if(this.input.value != ''){
            this.open();
        }
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
        this.predictiveSearchResults.classList.remove('hidesearch');
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
        this.predictiveSearchResults.classList.add('hidesearch');
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

    showSuggestedTitle(show) {
        const suggestedTitle = this.querySelector('.suggested-title');
        if (suggestedTitle) {
            suggestedTitle.style.display = show ? 'block' : 'none';
        }
    }
}

customElements.define('predictive-searchse', PredictiveSearch);
